import React from "react";
import { Flex, Text, Stack } from "@mantine/core";
import { IconPencil } from "@tabler/icons-react";

export default function SurveyMeta({ name, submitted }) {
  return (
    <Flex align="center" gap="xs">
      <IconPencil size="50" />
      <Stack gap={1}>
        <Text fw={700}>{name}</Text>
        {submitted && <Text>Submitted on {submitted}</Text>}
        {!submitted && <Text>Not submitted yet...</Text>}
      </Stack>
    </Flex>
  );
}

SurveyMeta.defaultProps = {
  name: "",
  submitted: "",
};
